var map = {
	"./countries-complete.json": 484,
	"./countries-currency.json": 485,
	"./countries-flag.json": 486,
	"./countries-jurisdiction.json": 487,
	"./countries-phone.json": 488,
	"./countries-territory.json": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 283;